import dayjs from "dayjs";
import CommonButton from "@/components/common/button/CommonButton";
import { THEME } from "@/constants";
import { presetDates } from "@/constants/app_constants.ts";

type PresetDateRangeProps = {
  activeLabel: string | null;
  setActiveLabel: (label: string | null) => void;
  startDate: dayjs.Dayjs | null;
  endDate: dayjs.Dayjs | null;
  setStartDate: (date: dayjs.Dayjs) => void;
  setEndDate: (date: dayjs.Dayjs) => void;
};

export default function PresetDateRange({ activeLabel, setActiveLabel, setEndDate, setStartDate }: PresetDateRangeProps) {
  const handlePresetClick = (label: string, rangeFn: () => [dayjs.Dayjs, dayjs.Dayjs]) => {
    const [start, end] = rangeFn();
    setStartDate(start);
    setEndDate(end);
    setActiveLabel(label);
  };

  return (
    <div className="preset-range w-[120px] h-[436px] text-sm flex flex-col">
      {presetDates.map(presetDate => (
        <CommonButton
          label={presetDate.label}
          backgroundColor={activeLabel === presetDate.label ? THEME.COLORS.PRIMARY : THEME.COLORS.WHITE}
          className={`cursor-pointer text-left pl-4 rounded-md h-[40px] mb-1 btn-calendar ${activeLabel === presetDate.label ? "text-white" : "text-gray-900"}`}
          key={presetDate.label}
          onClick={
            presetDate.label !== "Custom" ? () => handlePresetClick(presetDate.label, () => [presetDate.range[0], presetDate.range[1]]) : undefined
          }
        />
      ))}
    </div>
  );
}
